import * as React from "react";
import moment from "moment";
import { Card, Icon, Grid } from "tabler-react";

import { IJob } from "types/job";
import { makeSlug } from "../../utils/Utility";

export interface Props {
  jobs: IJob;
}

class JobCard extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.makeTitle = this.makeTitle.bind(this);
  }

  makeTitle(title) {
    return title
      .split(" ")
      .filter(function (name) {
        return name !== "-";
      })
      .toString()
      .replace(/,/g, "-");
  }

  render() {
    return (
      <a
        href={`/job/${
          makeSlug(this.props.jobs.title) + "-" + this.props.jobs.id
        }`}
        style={{
          textDecoration: "none",
          color: "#000000",
        }}
      >
        <Card className="job-card">
          <Card.Body className="job-card-body">
            <Card.Title className="mb-card">{this.props.jobs.title}</Card.Title>
            {/* <p className="mb-card">
              {this.props.jobs.organization
                ? this.props.jobs.organization.name
                : "HireXL"}
            </p> */}
            <p>
              <Icon name="briefcase" /> {this.props.jobs.experience.min} -{" "}
              {this.props.jobs.experience.max} Years &nbsp;{" "}
              <Icon name="map-pin" />
              {this.props.jobs.location}
            </p>
            <Grid.Row>
              <Grid.Col width={2} className="color-muted">
                Key Area:
              </Grid.Col>
              <Grid.Col width={10}>
                {this.props.jobs.functionalArea
                  ? this.props.jobs.functionalArea.secondary
                  : "Hiring"}
              </Grid.Col>
              <Grid.Col width={2} className="color-muted">
                Description:
              </Grid.Col>
              <Grid.Col width={10}>
                {this.props.jobs.description
                  .replace(/<[^>]*>/g, "")
                  .slice(0, 150)}
                ...
              </Grid.Col>
            </Grid.Row>
          </Card.Body>
          <Card.Footer>
            <Grid.Row>
              <Grid.Col width={6} className="padding-none">
                <Icon name="calendar" />{" "}
                {moment(this.props.jobs.createdAt).fromNow()}
              </Grid.Col>
              <Grid.Col width={6} className="padding-none text-right">
                {/* <img src="static/images/rupee.png" alt="Rupee" width="10" />{" "}
                {this.props.jobs.salary.min} - {this.props.jobs.salary.max} LPA */}
              </Grid.Col>
            </Grid.Row>
          </Card.Footer>
        </Card>
      </a>
    );
  }
}

export default JobCard;
